import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/lib/supabase";

export interface Plan {
  id: string;
  name: string;
  price_monthly: number;
  conversations_included: number;
  agents_included: number;
  extra_agent_price: number;
  description: string | null;
  is_custom: boolean;
  sort_order: number;
  assigned_org_id: string | null;
  billing_mode: string | null;
  per_conversation_price: number | null;
  payment_mode?: string | null;
  payment_strategy?: "preapproval" | "manual_oneshot" | "cash" | null;
  billing_frequency_type?: string | null;
  billing_frequency?: number | null;
  grace_days?: number | null;
  minimum_charge?: number | null;
  credit_limit?: number | null;
  archived_at?: string | null;
}

export function getPerConversationPrice(plan: { price_monthly?: number | null; conversations_included?: number | null; billing_mode?: string | null; per_conversation_price?: number | null } | null | undefined): number {
  if (!plan) return 0;
  const included = plan.conversations_included ?? 0;
  if (plan.billing_mode !== "per_use" && included > 0 && (plan.price_monthly ?? 0) > 0) {
    return Math.round(plan.price_monthly / included);
  }
  return plan.per_conversation_price ?? 0;
}

export function usePlans(includeCustom = false) {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPlans = useCallback(async () => {
    let query = supabase
      .from("plans")
      .select("*")
      .order("sort_order");
    if (!includeCustom) {
      query = query.eq("is_custom", false);
    }
    const { data, error } = await query;
    if (!error && data) setPlans(data as Plan[]);
    setLoading(false);
  }, [includeCustom]);

  useEffect(() => { fetchPlans(); }, [fetchPlans]);

  return { plans, loading, refetch: fetchPlans };
}
